export default "<div class=\"bg\">\r\n          <img src=\"../../../assets/images/BG_V1.jpeg\" alt=\" \">\r\n       \r\n</div>";